const RESET_DELAY_MS = 1600;

function label(icon: string, text: string): string {
  return `<md-icon slot="icon" aria-hidden="true">${icon}</md-icon>${text}`;
}

export function initCopyButtons(): void {
  const blocks = document.querySelectorAll<HTMLElement>('.prose pre, .code-block, .highlight pre');
  for (const block of blocks) {
    const button = document.createElement('md-text-button');
    button.className = 'copy-btn';
    button.setAttribute('type', 'button');
    button.innerHTML = label('content_copy', 'Copy');

    button.addEventListener('click', () => {
      const code = block.querySelector<HTMLElement>('code');
      void navigator.clipboard
        .writeText(code ? code.innerText : block.innerText)
        .then(() => {
          button.innerHTML = label('check', 'Copied');
          setTimeout(() => {
            button.innerHTML = label('content_copy', 'Copy');
          }, RESET_DELAY_MS);
        })
        .catch(() => {
          button.innerHTML = label('error', 'Failed');
          setTimeout(() => {
            button.innerHTML = label('content_copy', 'Copy');
          }, RESET_DELAY_MS);
        });
    });

    block.appendChild(button);
  }
}
